import * as actionTypes from '../actions/actionTypes';
import { GET_TENANT_INVOICE_FAIL, GET_TENANT_INVOICE_SUCCESS } from '../actions/actionTypes';

export const tenantsInitialState = {
  tenants: {
    loading: false,
    loaded: false,
    data: [],
    error: null
  },
  tenantDetails: {
    loading: false,
    loaded: false,
    data: null,
    error: null
  },
  crumps: {
    crumps: {
      tenantid: '',
      tenantname: '',
      assetid: '',
      assetname: '',
      portfolioid: '',
      portfiolioname: ''
    },
    loading: false,
    loaded: false,
    error: null
  },
  allIds: [],
  byId: [],
  totalRentByAsset: {
    loading: false,
    loaded: false,
    data: null,
    error: null
  },
  invoices: {
    loading: false,
    loaded: false,
    data: null,
    error: null
  },
  invoiceSettings: {
    loading: false,
    loaded: false,
    data: null,
    error: null
  },
  invoiceRecipients: {
    data: null,
    error: null
  },
  tenantInvoices: {
    data: null,
    error: null
  }
};

const reducer = (state = tenantsInitialState, action) => {
  switch (action.type) {
    case actionTypes.GET_TENANTS_START:
      return {
        ...state,
        tenants: {
          loading: true
        }
      };
    case actionTypes.GET_TENANTS_SUCCESS:
      return {
        ...state,
        tenants: {
          loading: false,
          loaded: true,
          tenants: action.tenants
        },
        byId: state.byId.some((id) => id === action.bundleId)
          ? state.byId
          : [...state.byId, action.bundleId],
        allIds: { ...state.allIds, [action.bundleId]: [...action.tenants] }
      };
    case actionTypes.GET_TENANTS_FAIL:
      return {
        ...state,
        tenants: {
          loading: false,
          loaded: true,
          error: action.error
        }
      };
    case actionTypes.SET_TENANTS_BUNDLE: {
      return {
        ...state,
        tenants: {
          ...state.tenants,
          tenants: state.allIds[action.bundleId]
        }
      };
    }

    case actionTypes.GET_BREADCRUMPS_START:
      return {
        ...state,
        crumps: {
          ...state.crumps,
          loading: true
        }
      };
    case actionTypes.GET_BREADCRUMPS_SUCCESS:
      return {
        ...state,
        crumps: {
          ...state.crumps,
          loading: false,
          loaded: true,
          crumps: action.crumps,
          error: null
        }
      };
    case actionTypes.GET_BREADCRUMPS_FAIL:
      return {
        ...state,
        crumps: {
          ...state.crumps,
          loading: false,
          error: action.error,
          loaded: true
        }
      };

    case actionTypes.GET_TENANTS_DETAILS_START:
      return {
        ...state,
        tenantDetails: {
          ...state.tenantDetails,
          loading: true
        }
      };
    case actionTypes.GET_TENANTS_DETAILS_SUCCESS:
      return {
        ...state,
        tenantDetails: {
          ...state.tenantDetails,
          loading: false,
          loaded: true,
          data: action.tenantDetails
        }
      };
    case actionTypes.GET_TENANTS_DETAILS_FAIL:
      return {
        ...state,
        tenantDetails: {
          ...state.tenantDetails,
          loading: false,
          loaded: true,
          error: action.error
        }
      };
    case actionTypes.GET_TOTAL_RENT_BY_ASSET_AND_YEAR_START:
      return {
        ...state,
        totalRentByAsset: {
          ...state.totalRentByAsset,
          loading: true
        }
      };
    case actionTypes.GET_TOTAL_RENT_BY_ASSET_AND_YEAR_SUCCESS:
      return {
        ...state,
        totalRentByAsset: {
          ...state.totalRentByAsset,
          loading: false,
          loaded: true,
          data: action.totalRentByAsset
        }
      };
    case actionTypes.GET_TOTAL_RENT_BY_ASSET_AND_YEAR_FAIL:
      return {
        ...state,
        totalRentByAsset: {
          ...state.totalRentByAsset,
          loading: false,
          loaded: true,
          error: action.error
        }
      };
    case actionTypes.GET_INVOICES_START:
      return {
        ...state,
        invoices: {
          loading: true
        }
      };
    case actionTypes.GET_INVOICES_SUCCESS:
      return {
        ...state,
        invoices: {
          loading: false,
          loaded: true,
          data: action.data
        }
      };
    case actionTypes.GET_INVOICES_FAIL:
      return {
        ...state,
        invoices: {
          loading: false,
          loaded: true,
          error: action.error
        }
      };
    case actionTypes.GET_INVOICE_SETTINGS_SUCCESS:
      return {
        ...state,
        invoiceSettings: {
          loading: false,
          loaded: true,
          data: action.data
        }
      };
    case actionTypes.GET_INVOICE_SETTINGS_FAIL:
      return {
        ...state,
        invoiceSettings: {
          loading: false,
          loaded: true,
          error: action.error
        }
      };
    case actionTypes.GET_INVOICE_RECIPIENTS_SUCCESS:
      return {
        ...state,
        invoiceRecipients: {
          data: action.data
        }
      };
    case actionTypes.GET_INVOICE_RECIPIENTS_FAIL:
      return {
        ...state,
        invoiceRecipients: {
          error: action.error
        }
      };
    case actionTypes.GET_TENANT_INVOICE_SUCCESS:
      return {
        ...state,
        tenantInvoices: {
          data: action.data
        }
      };
    case actionTypes.GET_TENANT_INVOICE_FAIL:
      return {
        ...state,
        tenantInvoices: {
          error: action.error
        }
      };
    default:
      return state;
  }
};

export default reducer;
